import axios from 'axios';

export const KLAVIYO_REPORT_TABLES = {
    klaviyo_campaigns: {
        title: 'Klaviyo Campaigns',
        columns: [
            { key: 'id', label: 'id' },
            { key: 'klaviyo_id', label: 'klaviyo_id' },
            { key: 'name', label: 'name' },
            { key: 'channel', label: 'channel' },
            { key: 'status', label: 'status' },
            { key: 'audiences_included', label: 'audiences_included' },
            { key: 'audiences_excluded', label: 'audiences_excluded' },
            { key: 'send_strategy', label: 'send_strategy' },
            { key: 'scheduled_at', label: 'scheduled_at' },
            { key: 'send_time', label: 'send_time' },
            { key: 'subject_line', label: 'subject_line' },
            { key: 'tags', label: 'tags' },
            { key: 'archived', label: 'archived' },
            { key: 'klaviyo_created_at', label: 'klaviyo_created_at' },
            { key: 'klaviyo_updated_at', label: 'klaviyo_updated_at' },
        ],
        searchPlaceholder: 'Search name, klaviyo_id, status, channel...',
        description: 'Campaigns data from Klaviyo.',
    },
    klaviyo_campaign_performance: {
        title: 'Klaviyo Campaign Performance',
        columns: [
            { key: 'id', label: 'id' },
            { key: 'campaign_klaviyo_id', label: 'campaign_klaviyo_id' },
            { key: 'channel', label: 'channel' },
            { key: 'fetched_at', label: 'fetched_at' },
            { key: 'recipients', label: 'recipients', align: 'right' },
            { key: 'delivered', label: 'delivered', align: 'right' },
            { key: 'opens', label: 'opens', align: 'right' },
            { key: 'opens_unique', label: 'opens_unique', align: 'right' },
            { key: 'open_rate', label: 'open_rate', align: 'right' },
            { key: 'clicks', label: 'clicks', align: 'right' },
            { key: 'clicks_unique', label: 'clicks_unique', align: 'right' },
            { key: 'click_rate', label: 'click_rate', align: 'right' },
            { key: 'unsubscribes', label: 'unsubscribes', align: 'right' },
            { key: 'unsubscribe_rate', label: 'unsubscribe_rate', align: 'right' },
            { key: 'bounces', label: 'bounces', align: 'right' },
            { key: 'bounce_rate', label: 'bounce_rate', align: 'right' },
            { key: 'spam_complaints', label: 'spam_complaints', align: 'right' },
            { key: 'conversion_uniques', label: 'conversion_uniques', align: 'right' },
            { key: 'conversion_value', label: 'conversion_value', align: 'right' },
            { key: 'revenue', label: 'revenue', align: 'right' },
        ],
        searchPlaceholder: 'Search campaign_klaviyo_id, channel...',
        description: 'Campaign performance data from Klaviyo.',
    },
    klaviyo_flows: {
        title: 'Klaviyo Flows',
        columns: [
            { key: 'id', label: 'id' },
            { key: 'klaviyo_id', label: 'klaviyo_id' },
            { key: 'name', label: 'name' },
            { key: 'status', label: 'status' },
            { key: 'trigger_type', label: 'trigger_type' },
            { key: 'archived', label: 'archived' },
            { key: 'tags', label: 'tags' },
            { key: 'klaviyo_created_at', label: 'klaviyo_created_at' },
            { key: 'klaviyo_updated_at', label: 'klaviyo_updated_at' },
        ],
        searchPlaceholder: 'Search name, klaviyo_id, status, trigger_type...',
        description: 'Flows data from Klaviyo.',
    },
    klaviyo_flow_performance: {
        title: 'Klaviyo Flow Performance',
        columns: [
            { key: 'id', label: 'id' },
            { key: 'flow_klaviyo_id', label: 'flow_klaviyo_id' },
            { key: 'flow_message_id', label: 'flow_message_id' },
            { key: 'channel', label: 'channel' },
            { key: 'fetched_at', label: 'fetched_at' },
            { key: 'recipients', label: 'recipients', align: 'right' },
            { key: 'delivered', label: 'delivered', align: 'right' },
            { key: 'opens', label: 'opens', align: 'right' },
            { key: 'opens_unique', label: 'opens_unique', align: 'right' },
            { key: 'open_rate', label: 'open_rate', align: 'right' },
            { key: 'clicks', label: 'clicks', align: 'right' },
            { key: 'clicks_unique', label: 'clicks_unique', align: 'right' },
            { key: 'click_rate', label: 'click_rate', align: 'right' },
            { key: 'unsubscribes', label: 'unsubscribes', align: 'right' },
            { key: 'bounces', label: 'bounces', align: 'right' },
            { key: 'conversion_uniques', label: 'conversion_uniques', align: 'right' },
            { key: 'conversion_value', label: 'conversion_value', align: 'right' },
            { key: 'revenue', label: 'revenue', align: 'right' },
        ],
        searchPlaceholder: 'Search flow_klaviyo_id, flow_message_id, channel...',
        description: 'Flow performance data from Klaviyo.',
    },
    klaviyo_lists: {
        title: 'Klaviyo Lists',
        columns: [
            { key: 'id', label: 'id' },
            { key: 'klaviyo_id', label: 'klaviyo_id' },
            { key: 'name', label: 'name' },
            { key: 'profile_count', label: 'profile_count', align: 'right' },
            { key: 'opt_in_process', label: 'opt_in_process' },
            { key: 'klaviyo_created_at', label: 'klaviyo_created_at' },
            { key: 'klaviyo_updated_at', label: 'klaviyo_updated_at' },
        ],
        searchPlaceholder: 'Search name, klaviyo_id, opt_in_process...',
        description: 'Lists data from Klaviyo.',
    },
    klaviyo_segments: {
        title: 'Klaviyo Segments',
        columns: [
            { key: 'id', label: 'id' },
            { key: 'klaviyo_id', label: 'klaviyo_id' },
            { key: 'name', label: 'name' },
            { key: 'profile_count', label: 'profile_count', align: 'right' },
            { key: 'is_active', label: 'is_active' },
            { key: 'is_starred', label: 'is_starred' },
            { key: 'klaviyo_created_at', label: 'klaviyo_created_at' },
            { key: 'klaviyo_updated_at', label: 'klaviyo_updated_at' },
        ],
        searchPlaceholder: 'Search name, klaviyo_id...',
        description: 'Segments data from Klaviyo.',
    },
    klaviyo_metrics: {
        title: 'Klaviyo Metrics',
        columns: [
            { key: 'id', label: 'id' },
            { key: 'klaviyo_id', label: 'klaviyo_id' },
            { key: 'name', label: 'name' },
            { key: 'integration_id', label: 'integration_id' },
            { key: 'integration_name', label: 'integration_name' },
            { key: 'integration_category', label: 'integration_category' },
            { key: 'klaviyo_created_at', label: 'klaviyo_created_at' },
            { key: 'klaviyo_updated_at', label: 'klaviyo_updated_at' },
        ],
        searchPlaceholder: 'Search name, klaviyo_id, integration...',
        description: 'Metrics data from Klaviyo.',
    },
    klaviyo_metric_aggregates: {
        columns: [
            { key: 'id', label: 'id' },
            { key: 'metric_klaviyo_id', label: 'metric_klaviyo_id' },
            { key: 'metric_name', label: 'metric_name' },
            { key: 'date', label: 'date' },
            { key: 'count', label: 'count', align: 'right' },
            { key: 'unique_count', label: 'unique_count', align: 'right' },
            { key: 'sum_value', label: 'sum_value', align: 'right' },
        ],
        searchPlaceholder: 'Search metric_name, metric_klaviyo_id...',
        description: 'Metric aggregates data from Klaviyo.',
    },
};

export function renderKlaviyoCell(column, row) {
    const value = row?.[column.key];
    if (value === null || value === undefined || value === '') return '—';
    if (typeof value === 'boolean') return value ? 'true' : 'false';
    if (typeof value === 'object') {
        try {
            return JSON.stringify(value);
        } catch {
            return String(value);
        }
    }
    return String(value);
}

export async function fetchAllKlaviyoReportData({ table, search, totalRecords }) {
    if (!totalRecords) return [];

    const pageSize = 500;
    const totalPages = Math.ceil(Number(totalRecords) / pageSize);
    const items = [];

    for (let page = 1; page <= totalPages; page += 1) {
        const { data } = await axios.get(`/api/v1/klaviyo/reports/${table}`, {
            params: {
                page,
                limit: pageSize,
                search: search || undefined,
            },
        });
        items.push(...(data?.items || []));
        if (!(data?.items || []).length) break;
    }

    return items;
}
